import { z } from 'zod/v4';

/** Serializable navigation state; never carries authority or refresh commands. */
export const proposalReviewSearchSchema = z.object({
  tab: z
    .enum(['stock-control', 'settings', 'warehouse-mapping', 'stock-sources', 'proposals'])
    .optional()
    .catch(undefined),
  proposalLocation: z
    .string()
    .regex(/^gid:\/\/shopify\/Location\/[0-9]+$/u)
    .max(100)
    .optional()
    .catch(undefined),
  proposalPage: z.coerce.number().int().min(1).max(100_000).optional().catch(undefined),
  proposalPageSize: z.coerce.number().int().min(1).max(100).optional().catch(undefined),
  proposalQ: z.string().trim().max(200).optional().catch(undefined),
  proposalStatus: z.enum(['all', 'blocked', 'changed', 'aligned']).optional().catch(undefined),
});

export type ProposalReviewSearch = z.infer<typeof proposalReviewSearchSchema>;
export interface ProposalReviewNavigation {
  reviewSearch?: ProposalReviewSearch;
  onReviewSearchChange?: (patch: Partial<ProposalReviewSearch>) => void;
}
